var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDe = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 37,
    viewBox: "0 0 39 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_634_1517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 39,
    height: 37
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.175 36.2242C29.7651 36.2242 38.35 28.1151 38.35 18.1121C38.35 8.10906 29.7651 0 19.175 0C8.58494 0 0 8.10906 0 18.1121C0 28.1151 8.58494 36.2242 19.175 36.2242Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_634_1517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.1335 0H-12.7832V12.0747H51.1335V0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1335 12.0747H-12.7832V24.1494H51.1335V12.0747Z",
    fill: "#DD0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1335 24.1494H-12.7832V36.2242H51.1335V24.1494Z",
    fill: "#FFCE00"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDe);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/De.382ee20484028bf8fc03b3d6cebd6a6b.svg";